import { mockData } from './MockData';
import { ApplicationsColumns } from '../../../services/column-definitions';

export const getDataGridProps = () => ({ rows: mockData, columns: ApplicationsColumns() });
